import { Environment } from "../types/environment";

const environment: Environment = {
  API_URL: "https://api.connect-events.fr/api",
  API_HOST: "https://api.connect-events.fr",
  NEXT_PUBLIC_DOCUMENTS_BUCKET_NAME: "ac-expo-bucket-prod-files",
  NEXT_PUBLIC_MEDIAS_BUCKET_NAME: "ac-expo-bucket-prod-medias",
  NEXT_PUBLIC_TICKETS_BUCKET_NAME: "ac-expo-bucket-prod-tickets",
  BACKOFFICE_URL: "https://app.connect-events.fr",
  NEXT_MEDIAS_CLOUDFRONT_BASE_URL: "https://d7roni70vs32b.cloudfront.net",
  NEXT_BASE_URL: "https://www.connect-events.fr",
  NEXT_PUBLIC_SENTRY_DSN:
    "https://12eafa44ba129b090f8fd9784448c8a8@o4509627932999680.ingest.de.sentry.io/4509638775799888",
};

export default environment;
